<template>
  <div class="ti-contact-information">
    <FormComponent
      v-if="step.form"
      :key="step.stepId"
      :form="step.form"
      :updating="updating"
      @formChanged="formChanged"
      @getStep="getStep"
    />

    <NotificationComponent
      v-if="notification && notification.message"
      :notification="notification"
      :currentStepId="step.stepId"
      @closeNotification="closeNotification"
    />

    <NavigationComponent
      :step="step"
      :history="history"
      :key="step.stepId"
      @nextClicked="nextClicked"
      @prevClicked="prevClicked"
    />
  </div>
</template>
<script lang="ts" setup>
import { Step, Form } from '@tradein/api';
import { Notification, StepIds } from '@tradein/store';

import FormComponent from '../../components/form/form.vue';
import NavigationComponent from '../../components/navigation/navigation.vue';
import NotificationComponent from '../../components/notification/notification.vue';
import {
  checkStepFormValid,
  saveFormElementValues,
} from '../../components/form/utils';
import { onMounted } from 'vue';

interface Props {
  history: Step[];
  step: Step;
  loading: boolean;
  updating: boolean;
  notification: Notification;
}

const props = defineProps<Props>();
const emit = defineEmits([
  'stepChanged',
  'getStep',
  'nextClicked',
  'prevClicked',
  'closeNotification',
]);

onMounted(() => {
  props.step.form && formChanged(props.step.form);
});

const formChanged = (form: Form): void => {
  props.step.completed = checkStepFormValid(props.step);
  props.step.form = form;

  if (props.step.completed && props.step.stepId !== StepIds.desiredvehicle) {
    saveFormElementValues(props.step.form, [
      'name',
      'email',
      'title',
      'firstname',
      'lastname',
      'surname',
      'phone',
    ]);
  }
  emit('stepChanged', props.step);
};

const getStep = (stepId: string): void => {
  emit('getStep', stepId);
};

const nextClicked = (): void => {
  emit('nextClicked', { delay: !props.step.data.dealerInfo ? 1500 : 0 });
};

const prevClicked = (): void => {
  emit('prevClicked');
};

const closeNotification = (): void => {
  emit('closeNotification');
};
</script>
<style lang="scss">
.ti-contact-information {
  width: 100%;
}
</style>
